// extracted by mini-css-extract-plugin
module.exports = {"iconSvgWrapper":"_2Yd7iD","iconSvg":"_3yIp3n"};